// extracted by mini-css-extract-plugin
export default {"cls1":"CoreXNav-cls1___67992b9d72caf85dd0b","cls2":"CoreXNav-cls2___c91b4c08a08d6b83f7f CoreXNav-cls1___67992b9d72caf85dd0b"};